import * as React from "react";
import { PropertyFiltersComponentProps } from "../typings";
import { UitkRadio } from "uitk-react-switch";
import { FlexClickTracker } from "components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { withStores } from "src/stores";
import { observer } from "mobx-react";

const RadioButtonTracked = FlexClickTracker(UitkRadio);

export const Radio = withStores("propertyFilters")(
  observer((props: PropertyFiltersComponentProps) => {
    const { filterName, option, propertyFilters, moduleName } = props;

    const onChange = () => {
      propertyFilters.toggleSelection(filterName, option.optionValue!);
    };

    const isSelected = propertyFilters.isSelected(filterName, option.optionValue!);

    return (
      <RadioButtonTracked
        events="click"
        id={`${filterName}-${option.optionValue}`}
        label={option.label}
        moduleName={moduleName}
        rfrr={`${moduleName}.${filterName}.${option.optionValue}.${!isSelected}`}
        value={option.optionValue}
        checked={isSelected}
        onChange={onChange}
        description={option.description}
        autoComplete="off"
      />
    );
  })
);
